<template>
  <v-dialog v-model="isShowing" persistent>
    <v-card>
      <v-toolbar color="green lighten-2" dense flat>
        <v-toolbar-title class="white--text">URL送信先メールアドレスを入力</v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card style="padding: 30px;">
        <h3>URL
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">help</v-icon>
            </template>
            <span>表示されているURLにアクセスをすると一時保存した内容を表示・編集できます。<br>
              一時保存をする場合はコピーをして保存するか、メールアドレスを入力してください。</span>
          </v-tooltip>
          </h3>
        <v-text-field single-line outlined v-model="temporaryDocumentURL" solo readonly>
          <template slot="append">
          <v-btn small outlined @click="copyTemporaryDocumentURL">
                コピー
              </v-btn>
          </template>
        </v-text-field>
        <h3>URL送信先メールアドレスの追加
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">help</v-icon>
            </template>
            <span>入力したメールアドレス宛にURLを送信できます。<br>URLを保存・共有したい場合にメールアドレスを入力してください。</span>
          </v-tooltip>
        </h3>
        <v-text-field single-line outlined v-model="inputMailAddress"
                      placeholder=">>> URL送信先メールアドレスを入力し + ボタンをクリック または Enterキーを押下"
                      append-icon='add_circle_outline'
                      @click:append="addMailAddress"
                      @keydown.enter="addMailAddress"></v-text-field>
        <h3>URL送信先メールアドレス</h3>
        <div style="border: solid 1px; margin-bottom: 22px">
          <ul v-for="(mailAddress, index) in mailAddresses" :key="index">
            <li><input :value="mailAddress" type="text" class="my-1" style="width: 20em"
                       @input="editMailAddress(index, $event.target.value)"/>
              <v-icon @click="deleteMailAddress(index)">delete</v-icon>
            </li>
          </ul>
        </div>
      </v-card>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="warning" @click.native="cancel">キャンセル</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="info" @click.native="saveAndEdit" class="mr-10">一時保存をして入力を続行</v-btn>
          <v-btn color="success" @click.native="saveAndQuit">一時保存をして終了</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: 'TemporarySaveUrlMailAddressEditor',
  data () {
    return {
      isShowing: false,
      resolve: null,
      reject: null,
      url: '',
      inputMailAddress: '',
      mailAddresses: [],
      temporaryDocumentURL: ''
    }
  },
  methods: {
    open (temporaryDocumentURL) {
      this.isShowing = true
      this.temporaryDocumentURL = temporaryDocumentURL
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    copyTemporaryDocumentURL () {
      navigator.clipboard.writeText(this.temporaryDocumentURL)
        .then(() => {
          this.$toasted.success('URLをコピーしました。', {
            theme: 'toasted-primary',
            position: 'top-right',
            duration: 3000
          })
        })
        .catch(e => {
          this.$toasted.error('URLのコピーに失敗しました。もう1回実行して下さい。', {
            type: 'error',
            theme: 'toasted-primary',
            position: 'top-right',
            duration: 3000
          })
        })
    },
    addMailAddress (event) {
      if (event.keyCode === 13 || event.type === 'click') {
        if (!this.inputMailAddress.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,4}$/)) {
          this.$toasted.error('正しいメールアドレスを入力してください。', {
            theme: 'toasted-primary',
            position: 'top-right',
            duration: 5000
          })
          return
        }
        this.mailAddresses.push(this.inputMailAddress)
        this.inputMailAddress = ''
      }
    },
    editMailAddress (index, mailAddress) {
      this.mailAddresses[index] = mailAddress
    },
    deleteMailAddress (index) {
      this.mailAddresses.splice(index, 1)
    },
    saveAndQuit () {
      this.save(true)
    },
    saveAndEdit () {
      this.save(false)
    },
    async save (isQuit) {
      if (this.mailAddresses.length === 0) {
        const title = '確認'
        const message = 'URL送信先のメールアドレスが入力されていません。\nURLを紛失すると一時保存した内容を表示・編集することはできません。\n一時保存をしてよろしいでしょうか。'
        const options = {
          needAgree: true,
          needCancel: true
        }
        if (!await this.$root.$confirmer.open(title, message, options)) {
          return
        }
      }
      const payload = {
        isCancel: false,
        mailAddresses: this.mailAddresses,
        isQuit: isQuit
      }
      this.resolve(payload)
      this.isShowing = false
    },
    cancel () {
      const payload = {
        isCancel: true
      }
      this.resolve(payload)
      this.isShowing = false
    }
  }
}
</script>

<style scoped>
.v-tooltip__content {
  position: fixed!important;
}
</style>
